// extracted by mini-css-extract-plugin
export default {"wrapper":"main_wrapper__l24Jd","logo":"main_logo__i8Fon","buttons":"main_buttons__fR+rn"};